<template>
  <div class="menu-view">
    <ul>
      <li v-for="(item,index) in menuList" :key="index">
        <router-link :to="item.path" :class="activeNum === index ? 'isActive' : ''">{{item.text}}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: '',
  props: [],
  data () {
    return {
      activeNum: 0,
      menuList: [{
        text: '首页',
        path: '/'
      }, {
        text: '免费·特价',
        path: '/home/specialoffer'
      }, {
        text: '分类',
        path: '/home/classification'
      }, {
        text: '榜单',
        path: '/home/ranking'
      }, {
        text: '活动·主题',
        path: '/home/theme'
      }
      // , {
      //   text: '阅读卡',
      //   path: '/home/readingcard'
      // }
      ]
    }
  },
  mounted () {
    const path = this.$route.path
    let flag = false
    this.menuList.forEach((e, i) => {
      if (path.indexOf(e.path) !== -1) {
        this.activeNum = i
        flag = true
      }
    })
    if (!flag) {
      this.activeNum = 0
    }
  }
}
</script>
<style lang="less" scoped>
  @hoverColor: red;
  .menu-view{
    ul{
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      li{
        padding: 0 20px;
        a{
          color: black;
          text-decoration: none;
        }
        a:hover{
          color: @hoverColor;
        }
        .isActive{
          color: red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/menu/menu.vue